import { mapState, mapMutations } from 'vuex';
import { mapActions } from 'vuex';

import AppSelecionarContaBancariaDialog from '../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import AppLancamentoContaDialog from './dialogs/LancamentoContaReceberDialog.vue';
import AppGerarBoletoLancamentoDialog from './dialogs/GerarBoletoLancamentoDialog.vue';
import AppProrrogarLancamentoDialog from './dialogs/ProrrogarLancamentoDialog.vue'

import { Money } from "v-money";
import Util from '../../util/funcoes';
import { ESTADOS, STATUS_CONTA_RECEBER_PAGAR, FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR, BANCOS, STATUS_LANCAMENTO, TIPO_LANCAMENTO, TIPO_DOCUMENTO_CONTA } from '../../util/constantes';

export default {
  components: {
    AppSelecionarContaBancariaDialog,
    AppLancamentoContaDialog,
    AppGerarBoletoLancamentoDialog,
    AppProrrogarLancamentoDialog,

    Money
  },
  data() {
    return {
      infiniteLoadingId: 0,

      lancamentoSelecionado: { id: 0, status: "ABERTO" },

      loadingPlanos: false,
      loadingClientes: false,

      visibilidadeSelecionarContaBancariaDialog: false,
      visibilidadeLancamentoContaDialog: false,
      visibilidadeGerarBoletoLancamentoDialog: false,
      visibilidadeProrrogarLancamentoDialog: false,

      validacao: {
        cliente: [{ required: true }],
        contaPlanoConta: [{ required: true }],
        vencimento: [{ required: true, len: 10 }],
        quantidadeParcelas: [{ required: true, validator: this.validarParcelas }],
        valor: [{ required: true, type: 'number', min: 0.01 }],
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        sufix: " %",
        masked: false
      },

      tabSelecionada: 'detalhes',

      formaPagamento: 'VISTA',

      lancamentoRowSelecionado: undefined,

      hoverGravar: false,
      hoverAprovar: false,
      hoverDesaprovar: false,
      hoverRemover: false,
      hoverCancelar: false,
      hoverGerarFatura: false
    };
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "CONTAS_RECEBER"
          })[0];
      }
    }),
    ...mapState('contasReceberStore', {
      contasReceber(state) { return state.listaContasReceber },
      contaReceberPesquisa(state) { return state.contaReceberPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      contaReceber(state) { return state.contaReceberSelecionado },

      planosDisponiveis(state) { return state.planosDisponiveis },
      clientesDisponiveis(state) { return state.clientesDisponiveis },

      logs: state => state.logs
    }),
    contaIsNova() {
      return this.contaReceber.id === 0;
    },
    contaIsExistente() {
      return !this.contaIsNova;
    },

    exibirBotaoNovoContaReceber() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarContaReceber() {
      return(
        (this.contaIsNova && this.permissoes.cadastro && this.contaReceber.status === 'PROVISORIA' && this.tabSelecionada === 'detalhes')
        || (this.contaIsExistente && this.permissoes.alteracao && (this.contaReceber.status === 'PROVISORIA' || this.contaReceber.status === 'ABERTA'))
      )
    },
    exibirBotaoRemoverContaReceber() {
      return this.contaIsExistente && this.permissoes.remocao && (this.contaReceber.status === 'PROVISORIA' || this.contaReceber.status === 'CANCELADA');
    },
    exibirBotaoCancelarContaReceber() {
      return this.contaIsExistente && this.permissoes.cancelarConta && this.contaReceber.status === 'ABERTA';
    },
    exibirBotaoGerarEnviarEmail() {
      return this.contaIsExistente && this.tabSelecionada == 'lançamentos' && (this.lancamentoRowSelecionado && this.lancamentoRowSelecionado.status === 'ABERTO' && this.lancamentoRowSelecionado.tipo !== 'CHEQUE') && this.lancamentoRowSelecionado.tipo === 'BOLETO';  
    },
    exibirBotaoAprovarContaReceber() {
      return this.contaIsExistente && this.permissoes.aprovarDesaprovarConta && this.contaReceber.status === 'PROVISORIA';
    },
    exibirBotaoDesaprovarContaReceber() {
      return this.contaIsExistente && this.contaReceber.contaPlanoConta.id != 0 && this.permissoes.aprovarDesaprovarConta && this.contaReceber.status === 'ABERTA';
    },
    exibirBotaoGerarFaturaContaReceber() {
      return this.contaIsExistente && this.contaReceber.status === 'ABERTA';
    },
    exibirBotaoGerarRecibo() {
      return(
        (this.contaIsExistente && (this.contaReceber.status === 'ABERTA' || this.contaReceber.status === "PAGA"))
        && (this.lancamentoSelecionado.status === "EFETUADO")
        && (this.contaReceber.lancamentos.map(lancamento => lancamento.id).includes(this.lancamentoSelecionado.id))
        && this.tabSelecionada == 'lançamentos'
      );
    },
    exibirLancamentos() {
      return this.contaReceber.id != 0 && (this.contaReceber.status === 'ABERTA' || this.contaReceber.status === 'PAGA');
    },
    exibirBotaoNovoLancamento() {
      return this.contaReceber.status === 'ABERTA' && this.tabSelecionada === 'lançamentos';
    },
    exibirBotaoProrrogarLancamento() {
      return this.tabSelecionada === 'lançamentos' && this.lancamentoSelecionado.id > 0 && this.lancamentoSelecionado.status === 'ABERTO' && !this.lancamentoSelecionado.dataProrrogacao && this.lancamentoRowSelecionado.tipo === 'BOLETO';
    },
    exibirBotaoCancelarProrrogacao() {
      return this.tabSelecionada === 'lançamentos' && this.lancamentoSelecionado.id > 0 && this.lancamentoSelecionado.status === 'ABERTO' && this.lancamentoSelecionado.dataProrrogacao && this.lancamentoRowSelecionado.tipo === 'BOLETO';
    },
    nomeCliente(){
      return this.contaReceber.cliente ? this.contaReceber.cliente.nome : '';
    },
    nomeContaBancaria(){
      return this.contaReceber.contaBancaria ? this.contaReceber.contaBancaria.nome : ''
    },
    totalPago(){
      let totalPago = 0
      if(!this.contaReceber.lancamentos) return 0

      this.contaReceber.lancamentos.forEach(item => {
        if(item.status === 'EFETUADO'){
          totalPago += item.valor
        }
      });

      return totalPago
    },

    encargos() {
      let encargos = 0;
      if(!this.contaReceber.lancamentos) return 0
      
      this.contaReceber.lancamentos.forEach(item => {
        if(item.valorPago > item.valor) {
          encargos += item.valorPago - item.valor;
        }
      });

      return encargos
    },
    estados() { 
      return ESTADOS;
    },
    status() { 
      return STATUS_CONTA_RECEBER_PAGAR;
    },
    formasPagamento() { 
      return FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR;
    },
    tipoDocumento() {
      return TIPO_DOCUMENTO_CONTA;
    },
    util() { 
      return Util;
    },
    disableDataEmissao() {
      return this.contaReceber.status == 'ABERTA' || this.contaReceber.status == 'PAGA'
    },
    disableDataReconhecimento() {
      return this.permissoes.reconhecerConta == false || this.contaReceber.status != 'PROVISORIA';
    },
    exibirDataReconhecimento(){
      return this.contaReceber.id != 0;
    },

    isEditando() {
      return this.contaReceber.id !== 0;
    },

    isVisibleAbaLogs() {
      return this.isEditando;
    },

    contaIsAprovada() {
      return this.contaReceber.status === 'ABERTA';
    },

    isContaProvisoria() {
      return this.contaReceber.status === 'PROVISORIA'
    },

    spanFormaPagamento() {
      return this.formaPagamento == 'PARCELADO' ? 6 : 12;
    },

    listaDias() {
      let dias = [];
      for(let i = 30; i >= 1; i--) {
        let objetoLista = {}
        objetoLista.label = `${i}`;
        objetoLista.value = i;

        dias.push(objetoLista);
      }
      return dias
    },
    bloqueioMultaJuros() {
      return this.contaReceber.status === 'ABERTA'
    }
  },

  watch: {
    'contaReceber.id': function(newValue, oldValue) {
      if(oldValue !== 0) {
        this.limparLogs();
      }
    },
  },

  methods: {
    ...mapMutations('contasReceberStore', [
      'limparLogs'
    ]),
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('contasReceberStore', [
      'listarContasReceber',
      'limparContasReceberListadas',
      'limparContaReceberPesquisa',
      'recuperarContaReceber',
      'novoContaReceber',
      'gravarContaReceber',
      'removerContaReceber',
      'cancelarContaReceber',
      'aprovarContaReceber',
      'desaprovarContaReceber',
      'gerarRecibo',
      'listarPlanos',
      'listarClientes',
      'removerLancamentoConta',
      'recuperarLancamento',
      'novoLancamento',
      'recuperarLogs',
      'cancelarProrrogacaoLancamento'
    ]),
    ...mapActions('financeiroRelatoriosStore', [
      'gerarRelatorio'
    ]),

    validarParcelas(rule, value, callback) {
      if(value >= 2 && value <= 120) {
       return callback();
     } else {
       return callback(new Error())
     }
    },

    novo() {
      this.novoContaReceber();
      this.tabSelecionada = 'detalhes'
      this.formaPagamento = 'VISTA';
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },

    pesquisarHandler() {
      this.contaReceberPesquisa.pagina = 0;
      this.limparContasReceberListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.contaReceberPesquisa.pagina === 0) { this.showLoading(); }

      this.listarContasReceber(this.contaReceberPesquisa).then((resultado) => {
        if(this.contaReceberPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.contaReceberPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.contaReceberPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.contaReceberPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparPesquisa() {
      this.limparContaReceberPesquisa();
    },

    recuperarHandler(contaReceber) {
      this.recuperar(contaReceber);
    },
    recuperar(contaReceber) {
      this.showLoading();
      this.recuperarContaReceber(contaReceber).then((resultado) => {
        const contaRecuperada = resultado.item;
        if(contaRecuperada.quantidadeParcelas > 1) { this.formaPagamento = 'PARCELADO' }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      if(this.contaReceber.dataReconhecimento && this.contaReceber.dataEmissao) {
        if(this.util.compararDatas(this.contaReceber.dataReconhecimento, this.contaReceber.dataEmissao) == -1) {
          this.exibirAlert("Atenção", "Impossível inserir uma data de reconhecimento anterior a data de emissão")
          return;
        }
      }
      if(this.formaPagamento == 'VISTA') { this.contaReceber.quantidadeParcelas = 1 }
      this.showLoading();
      this.gravarContaReceber(this.contaReceber).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    removerHandler() {
      this.$confirm('Deseja realmente remover esta Conta?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerContaReceber(this.contaReceber).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    cancelarHandler() {
      this.$confirm('Deseja realmente cancelar esta Conta?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.cancelar();
      });
    },
    cancelar() {
      this.showLoading();
      this.cancelarContaReceber(this.contaReceber).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    aprovarHandler() {
      this.showLoading();
      this.aprovarContaReceber(this.contaReceber).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem)
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    desaprovarHandler() {
      this.$confirm('Ao desaprovar a conta todos os lançamentos são excluídos, inclusive lançamentos registrados e com remessas geradas.', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.desaprovar();
      })
    },

    desaprovar() {
      this.showLoading();
      this.desaprovarContaReceber(this.contaReceber).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gerarFaturaHandler() {
      let payload = { 
        nome: "FATURA_CONTA_RECEBER",
        conta: { id: this.contaReceber.id }
      };

      this.showLoading();
      this.gerarRelatorio(payload).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO": 
            window.open(resultado.mensagem, "_blank");
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gerarReciboHandler() {
      const lancamento = { id: this.lancamentoSelecionado.id };
      const relatorio = { nome: 'RECIBO_CLIENTE', lancamento };

      this.showLoading();
      this.gerarRecibo(relatorio).then(resultado => {
        this.hideLoading();

        switch(resultado.status) {
          case "FALHA":
            this.$message.warning("Erro ao gerar o Relatório");
            break;
          case "SUCESSO":
            window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    // LANCAMENTOS
    verificarRegistroLancamento(lancamento) {
      if(lancamento.dataRegistro) {
        this.$confirm('Este boleto está registrado e a remoção é definitiva! Inviabilizando qualquer baixa automática, caso ele também não tenha sido cancelado no seu banco.', 'Atenção', {  
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.removerLancamentoHandler(lancamento);
        })
        return;
      }

      this.removerLancamentoHandler(lancamento);
    },

    removerLancamentoHandler(lancamento) {
      if(lancamento.status !== "ABERTO") {
        this.$message.error("Só é possível excluir um lançamento aberto");
        return;
      }
      
      this.$confirm('Deseja realmente remover este Lançamento?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.removerLancamento(lancamento);
      });
    },
    removerLancamento(lancamento) {
      this.showLoading();
      this.removerLancamentoConta(lancamento).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    handleRecuperarLogs() {
      const payload = {
        conta: {
          id: this.contaReceber.id,
        },
        pagina: -1,
      };

      this.showLoading();

      this.recuperarLogs(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor")
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    selecionarLancamento(lancamento) {
      this.lancamentoRowSelecionado = lancamento
    },

    cancelarProrrogacaoHandler() {
      this.$confirm("Tem certeza que deseja cancelar a Prorrogação deste aluguel", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.showLoading();
        this.cancelarProrrogacaoLancamento({ id: this.lancamentoSelecionado.id })
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              this.lancamentoRowSelecionado = undefined
              this.lancamentoSelecionado = {}
              break;
            default:
              this.$message.error("Ocorreu um erro.");
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro");
        });
      });
    },

    // SELECTS
    filtrarPlanosSelect(queryString) {
      let payload = { nome: queryString, grupoPlanoConta: { tipo: 'RECEITA' } }
      this.loadingPlanos = true;
      this.listarPlanos(payload)
      .then(() => {
      this.loadingPlanos = false;  
      })
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
      this.loadingClientes = false;  
      })
    },

    // DIALOGS
    exibirSelecionarContaBancariaDialog() { 
      this.visibilidadeSelecionarContaBancariaDialog = true 
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) { 
        this.contaReceber.contaBancaria = contaBancaria
        this.visibilidadeSelecionarContaBancariaDialog = false; 
    },
    exibirLancamentoContaDialog() { 
      this.visibilidadeLancamentoContaDialog = true 
    },
    fecharLancamentoContaDialog(payload) {
        //this.contaReceber.lancamentos.push(lancamento)
        this.visibilidadeLancamentoContaDialog = false; 
        if(payload && payload.baixouLancamento) this.pesquisarHandler();
    },

    exibirGerarBoletoLancamentoDialog() {
      this.visibilidadeGerarBoletoLancamentoDialog = true
    },

    fecharGerarBoletoLancamentoDialog() {
      this.visibilidadeGerarBoletoLancamentoDialog = false;
    },

    exibirProrrogarLancamentoDialog() {
      this.visibilidadeProrrogarLancamentoDialog = true;
    },

    fecharProrrogarLancamentoDialog() {
      this.visibilidadeProrrogarLancamentoDialog = false;
    },

    // UTILS
    async recuperarLancamentoHandler(lancamento) {
      this.showLoading();
      
      try {
        await this.recuperarLancamento(lancamento);
        this.exibirLancamentoContaDialog();
      } catch(e) {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }

      this.hideLoading();
    },
    selecionarLancamentoHandler(lancamento) {
      if(lancamento == null) return;

      this.lancamentoSelecionado = lancamento;
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    coresPesquisa(status) {
      switch(status) {
        case "PROVISORIA":
          return "#4B6EF6";
        case "ABERTA":
          return "#2DB748";
        case "PAGA":
          return "#3A9AFE";
        case "CANCELADA":
          return "#DF1B1B";
      }
    },
    getLabelStatusConta(item) {
      return Util.getLabel(STATUS_CONTA_RECEBER_PAGAR, item);
    },
    getLabelStatusLancamento(item) {
      return Util.getLabel(STATUS_LANCAMENTO,item.status)
    },
    getLabelTipo(item) {
      return Util.getLabel(TIPO_LANCAMENTO,item.tipo)
    },
    getLabelBanco(item) {
      return Util.getLabel(BANCOS,item.bancoCheque)
    },
    getLabelTipoDocumentoConta(item) {
      return Util.getLabel(TIPO_DOCUMENTO_CONTA, item.tipoDocumento)
    },
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    formatarValor(item) {
      return Util.formatarValor(item)
    },
  }
}